import { useEffect, useState } from "react";
import AppHeader from "../../../components/header";
import { RichTextEditor } from "../../../components/textEditor";
import {
  getLegalContentByType,
  updateLegalContent,
} from "../../../services/LegalContentApi";
import { decodeHtml, handleOpenSnackBar } from "../../../utils/helper";
import AppLoader from "../../../components/loader";
import { Box, Tabs, Tab, Button, Stack } from "@mui/material";

const TAB_TYPES = {
  0: "terms-and-conditions",
  1: "privacy-policy",
};

const LegalContentPage = () => {
  const [loading, setLoading] = useState({
    get: true,
    update: false,
  });
  const [contentDetails, setContentDetails] = useState(null);
  const [content, setContent] = useState("");
  const [type, setType] = useState("privacy-policy");
  const [tabValue, setTabValue] = useState(1);

  const handleGetContent = async (type) => {
    setLoading((prev) => ({ ...prev, get: true }));
    try {
      const response = await getLegalContentByType(type);
      if (response.data.status === "success") {
        const data = response.data.data;
        setContentDetails(data);
        setContent(decodeHtml(data.content));
      } else {
        handleOpenSnackBar(
          "error",
          response.data.message || "Failed to fetch content",
        );
      }
    } catch (error) {
      handleOpenSnackBar("error", "Failed to fetch content");
    } finally {
      setLoading((prev) => ({ ...prev, get: false }));
    }
  };

  const handleUpdateContent = async () => {
    setLoading((prev) => ({ ...prev, update: true }));
    try {
      const response = await updateLegalContent(contentDetails._id, {
        content,
      });
      if (response.data.status === "success") {
        handleOpenSnackBar("success", "Content updated successfully");
      } else {
        handleOpenSnackBar(
          "error",
          response.data.message || "Failed to update content",
        );
      }
    } catch (error) {
      handleOpenSnackBar("error", "Failed to update content");
    } finally {
      setLoading((prev) => ({ ...prev, update: false }));
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setType(TAB_TYPES[newValue]);
  };

  useEffect(() => {
    if (type) {
      handleGetContent(type);
    }
  }, [type]);

  return (
    <AppHeader>
      <AppLoader isVisible={loading.get} />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Terms & Conditions" />
          <Tab label="Privacy Policy" />
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>
        <RichTextEditor value={content} onChange={(html) => setContent(html)} />
      </Box>

      <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleUpdateContent}
          disabled={loading.update || loading.get}
        >
          {loading.update ? "Updating..." : "Update"}
        </Button>
      </Stack>
    </AppHeader>
  );
};

export default LegalContentPage;
